import { Action } from '@ngrx/store';
import { GestionCaja } from '../../models/gestioncaja.model';

export const CARGAR_GESTION_CAJA = '[Gestión Caja] Cargar gestión caja';
export const CARGAR_GESTION_CAJA_FAIL = '[Gestión Caja] Cargar gestión caja Fail';
export const CARAGAR_GESTION_CAJA_SUCCESS = '[Gestión Caja] Cargar gestión caja success';
export const CARGAR_GESTION_CAJA_RESET = '[Gestión Caja] Cargar gestión caja reset';

export class CargarGestionCajaActions implements Action {
  readonly type = CARGAR_GESTION_CAJA;
}

export class CargarGestionCajaFailActions implements Action {
  readonly type = CARGAR_GESTION_CAJA_FAIL;

  constructor ( public payload: any ) {}
}

export class CargarGestionCajaSuccessActions implements Action {
  readonly type = CARAGAR_GESTION_CAJA_SUCCESS;

  constructor( public payload: GestionCaja[] ) {}
}

export class CargarGestionCajaResetActions implements Action {
  readonly type = CARGAR_GESTION_CAJA_RESET;

  constructor( public payload: any) {}
}

export type gestioncajaAcciones = CargarGestionCajaActions
                                    | CargarGestionCajaFailActions
                                    | CargarGestionCajaSuccessActions
                                    | CargarGestionCajaResetActions;



// WEBPACK FOOTER //
// ./src/store/actions/domiciliosappgestioncaja.actions.ts